import axios from 'axios'

export const useSgtkStatus = () => {
  const config = useRuntimeConfig()

  const getSgtkStatus = async () => {
    let retInfo = { content_id: '', cpselid: '' }
    try {
      const api = config.public.sgtkLoginApi
      const { data } = await axios.get(api)
      retInfo = {
        content_id: data.content_id || '',
        cpselid: data.contentselection_id || ''
      }
    } catch (error) {
      console.error('Error fetching Sgtk status:', error)
    }
    return retInfo
  }

  const checkId = async () => {
    const loginInfo = await getSgtkStatus()
    const cpselid = loginInfo.cpselid
    if (cpselid === '') {
      await navigateTo('https://www.sugotoku.docomo.ne.jp/cs/cpsite.html?url=https://dcsgtk.wni.co.jp/s/sample/index.html', {
        external: true
      })
    }
  }

  return { checkId }
}
